import {supportsHasPseudoClass} from "./utils/Utils.js";

// Menu
import MenuOverlayToggler from "./components/MenuOverlayToggler.js";

// Core blocks
import CoverVideo from "./components/core-blocks/CoverVideo.js";
import MediaTextVideo from "./components/core-blocks/MediaTextVideo.js";
import Video from "./components/core-blocks/Video.js";
import VimeoEmbed from "./components/core-blocks/VimeoEmbed.js";
import YouTubeEmbed from "./components/core-blocks/YouTubeEmbed.js";

// ACF blocks
import Slideshow from "./components/acf-blocks/Slideshow.js";
import TariffCalculator from "./components/acf-blocks/TariffCalculator.js";

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh/10}rem`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight/10}rem`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Enable event listener for pushState
const _wr = (type) => {
	const orig = history[type];
	return function() {
		const rv = orig.apply(this, arguments);
		const e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');

//
// Blocks
document.querySelectorAll('.wp-block-cover-wrapper.has-video').forEach(block => new CoverVideo(block));
document.querySelectorAll('.wp-block-media-text-wrapper.has-video').forEach(block => new MediaTextVideo(block));
document.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new VimeoEmbed(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(block => new YouTubeEmbed(block));
document.querySelectorAll('.wp-block-video-wrapper').forEach(domEl => new Video(domEl));

document.querySelectorAll('.acf-block-slideshow').forEach(domEl => new Slideshow(domEl));

new TariffCalculator();

//
// Menus
new MenuOverlayToggler();

//
// Menus
if(document.body.classList.contains('single-post')) {
	document.querySelectorAll('.menu_page-news').forEach(menuItem => {
		menuItem.classList.add('js-active');
	});
}